import{featureDefinitions as o}from"./definitions.mjs.js";function i(i){for(const n in i)o[n]={...o[n],...i[n]}}export{i as loadFeatures};
